import { render, staticRenderFns } from "./user-box.vue?vue&type=template&id=711259fb&scoped=true"
import script from "./user-box.vue?vue&type=script&lang=js"
export * from "./user-box.vue?vue&type=script&lang=js"
import style0 from "./user-box.vue?vue&type=style&index=0&id=711259fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711259fb",
  null
  
)

export default component.exports